// Import React and Hooks
import React, { useState } from 'react'
// Import React Awesome Reveal
import { Fade } from "react-awesome-reveal"



// Input Form Prop
interface inputFomProp {
  additionalClass?:string,
  inputData:any
}

const InputForm = ( { additionalClass, inputData }:inputFomProp ) => {



  // Destructuring
  const { register, errors, id, label, options, validation, placeholder, type, typeInput, maxlength } = inputData



  // Function
  function handleMaxLength( e:any ) {
    const blackListKeys:number[] = [8, 9, 13, 16, 17, 18, 32, 37, 38, 39, 40, 46]
    const el = e.target
    const dataLength:number = el.dataset.maxlength

    if( !blackListKeys.includes(e.keyCode) ) {
      if ( el.value.length > el.maxLength ) {
        el.value = dataLength ? el.value.slice(0, dataLength - 1) : el.value
      }
    }
  }

  function printValueAmount( id:string ):number {
    const inputEl = document.getElementById(id) as HTMLInputElement | HTMLTextAreaElement
    return inputEl && inputEl.value.length
  }



  return (
    <div className={`form__box ${ additionalClass ? additionalClass : ''} ${ type === 'checkbox' ? 'w100 form__box--checkbox' : ''}`}>
      { label && type !== "checkbox" && (
				<label
					htmlFor={id}
					className="form__label">
						{label}
				</label>
			) }
      { type === "checkbox" && (
				<>
					<input
						type={type}
						id={id}
						className="form__checkbox"
						{ ...register(id, validation) } />
					<label
						htmlFor={id}
						className="form__label form__label--checkbox"
						dangerouslySetInnerHTML={{ __html: label }} />
				</>
			) }
      { type === "select" && (
				<div className="form__select">
					<select
						className="form__select__item"
						name={id}
						id={id}
						{ ...register(id, validation) } >
							<option value="" hidden> {placeholder} </option>
							{ options.length > 0 && options.map( (optionEl:any, index:number) => (
								<option value={optionEl.value} key={`${optionEl.value}-${index}`}> {optionEl.text} </option>
							) ) }
					</select>
				</div>
			) }
      { type === "file" && (
				<input
					type={typeInput}
					id={id}
					className="form__input"
					{ ...register(id, validation) }
					inputMode={typeInput === 'number' ? 'numeric' : 'text'}
					placeholder={placeholder} />
			) }
      { type === "normal" && (
				<input
					type={typeInput}
					id={id}
					className="form__input"
					{ ...register(id, validation) }
					inputMode={typeInput === 'number' ? 'numeric' : 'text'}
          data-maxlength={ maxlength }
          onKeyDown={ (e:React.MouseEvent) => handleMaxLength(e) }
					placeholder={placeholder} />
			) }
      { type === "textarea" && (
        <>
          <textarea
            type={typeInput}
            id={id}
            className="form__textarea"
            { ...register(id, validation) }
            inputMode={typeInput === 'number' ? 'numeric' : 'text'}
            data-maxlength={ maxlength }
            onKeyDown={ (e:React.MouseEvent) => handleMaxLength(e) }
            placeholder={placeholder} />
          {/* <p style={{'color': 'white'}}> { printValueAmount(id) } </p> */}
        </>
			) }
      { errors[id] &&
				<Fade
          direction='up'
					duration={ 500 } >
					<p className="form__error">{ errors[id].message }</p>
				</Fade >
			}
    </div>
  )
}



export default InputForm
